const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/ECheckinForm.tsx';
import KontaktPerson from 'App/config/liho/eCheckin/sections/KontaktPerson';
import ECheckinSections from 'App/components/eCheckin/components/ECheckinSections';
import textMap from 'App/config/liho/eCheckin/translations';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import DirektAbrechnung from 'App/config/liho/eCheckin/sections/DirektAbrechnung';
import PersAngaben from 'App/config/liho/eCheckin/sections/PersAngaben';
import Versicherung from 'App/config/liho/eCheckin/sections/Versicherung';
import Arzt from 'App/config/liho/eCheckin/sections/Arzt';
import PatientenVerfuegung from 'App/config/liho/eCheckin/sections/PatientenVerfuegung';
import Arbeitgeber from 'App/config/liho/eCheckin/sections/Arbeitgeber';
import Kommentar from 'App/config/liho/eCheckin/sections/Kommentar';
import Behandlungsvereinbarung from 'App/config/liho/eCheckin/sections/Behandlungsvereinbarung';
import Finalize from 'App/components/eCheckin/components/sections/Finalize';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { makeSelectCIS4m } from '@cistec/common_web/modules/CIS4m/store';
import { useMadeSelector } from '@cistec/common_web/utils/store';

export const ECheckinForm = forwardRef((_props: {}, ref) => {
    const eCheckinSectionsRef = useCIS4m(ref);
    const { formId } = useCIS4mContext();
    const cis4mData = useMadeSelector(() => makeSelectCIS4m(formId), []);
    if (!cis4mData) return null;

    return (
        <ECheckinSections ref={eCheckinSectionsRef} cis4mData={cis4mData}>
            <DirektAbrechnung path="direktAbrechnung" title={textMap.direktabrechnung} />
            <PersAngaben path="persAngaben" title={textMap.persAngaben} />
            <KontaktPerson path="angehoerige" title={textMap.angehoerige} />
            <Arzt path="hausArzt" title={textMap.hausArzt} />
            <Versicherung path="versicherung" title={textMap.versicherung} />
            <Behandlungsvereinbarung path="behandlungsvereinbarung" title={textMap.behandlungsvereinbarung} />
            <PatientenVerfuegung path="patientenVerfuegung" title={textMap.patientenVerfuegungInfo} />
            <Arbeitgeber path="arbeitgeber" title={textMap.arbeitgeber} />
            <Kommentar path="kommentar" title={textMap.kommentare} />
            <Finalize path="finalize" />
        </ECheckinSections>
    );
});

ECheckinForm.displayName = 'ECheckinForm';

export default ECheckinForm;
